import axios from "axios";
import { ADMINAPI_BASE_URL } from "./base_urls"

const singleton = Symbol();
const singletonEnforcer = Symbol();

class ApiInterfaceForPublicRoute {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error("Cannot construct singleton");
    }

    this.session = axios.create({
      baseURL: `${ADMINAPI_BASE_URL}/api`,
      headers: {
        Accept: "application/json",
        'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
      },
    });
    this.session.defaults.timeout = 20 * 1000;
    this.session.defaults.validateStatus = (status) =>
      status >= 200 && status < 300;
    this.session.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    this.session.interceptors.request.use((request) => {
      return request;
    });
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new ApiInterfaceForPublicRoute(singletonEnforcer);
    }

    return this[singleton];
  }

  static reInstance() {
    this[singleton] = new ApiInterfaceForPublicRoute(singletonEnforcer);
  }

  get = (...params) => this.session.get(...params);
  post = (...params) => this.session.post(...params);
  put = (...params) => this.session.put(...params);
  patch = (...params) => this.session.patch(...params);
  remove = (...params) => this.session.delete(...params);

  register = (data) => this.session.post("/register/", data);
  login = (data) => this.session.post("/login/", data);
  loginGoogle = (data) => this.session.post("/rest-auth/google/", data);
  loginApple = (data) => this.session.post("/loginApple", data);
  invitation = (data) => this.session.post("/handle_invite/", data);
}

export default ApiInterfaceForPublicRoute;